// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"218":"f260d7595f8718aea0e1","591":"24052fedd4ce0af78fa3"}[chunkId] + ".js";
};